<template>
  <div class="p-1">
    <h4>Total Team Progress: {{ totalProgress }}%</h4>

    <b-table
      :items="tableData"
      :fields="fields"
      responsive
      bordered
    >
      <template #cell(teamProgress)="data">
        {{ data.item.teamProgress }}%
      </template>
    </b-table>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import { BTable } from 'bootstrap-vue'

export default {
  components: {
    BTable,
  },
  props: {
    stats: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const fields = ref([
      { key: 'target', label: 'Target number of trips' },
      { key: 'teamProgress', label: 'Percentage completion' },
      { key: 'kpiTotal', label: 'Number of completed trips' },
    ])

    const tableData = computed(() => props.stats.kpiProgress.map(item => ({
      target: item?.target,
      teamProgress: item?.teamProgress,
      kpiTotal: item?.kpiTotal || 0,
    })))

    const totalProgress = computed(() => props.stats.totalProgress)

    return {
      fields,
      tableData,
      totalProgress,
    }
  },
}
</script>
